export const welcomeJomatik = {
    welcomeToMurtfeldtAS: 'Wir strukturieren um.',
    dearJomatikCustomer: 'Lieber Kunde,',
    happyToSeeYou:
        'die JOMATIK ist nun Teil der Murtfeldt Gruppe und wurde in Murtfeldt Additive Solutions umbenannt. Aus diesem Grund strukturieren wir unseren Online-Auftritt um.',
    nameChange: 'heißt jetzt',
    everythingAsNormal: 'Für Sie bedeutet das: ',
    sameTeam: 'Wir bieten Ihnen ab sofort ein erweitertes Leistungsspektrum,',
    sameService: 'Wir sind dasselbe Team und sitzen weiter in Tübingen,',
    sameLogin:
        'Sie können sich mit Ihren gewohnten Zugangsdaten bei uns anmelden.',
    discount:
        'Als Dank für Ihre bisherige Treue erhalten Sie für Ihre nächste Bestellung <span class="has-text-primary">{amount}%</span> Rabatt mit dem Gutscheincode <span class="has-text-info">{code}</span>.',
    thankYou:
        'Wir danken Ihnen für Ihr Vertrauen und freuen uns auf die weitere Zusammenarbeit.<br/>Ihr Team von Murtfeldt Additive Solutions ',
    marketPlaceNote:
        'Bitte nutzen Sie zum Bestellen von Bauteilen zukünftig unser neues Portal <br/><a href=\'https://www.murtfeldt-as.de\' class="has-text-primary">murtfeldt-as.de</a>. Der Jomatik Markplatz bleibt vorläufig weiterhin für Sie verfügbar.',
    goToStart: 'Weiter ins neue Portal',
    goToMarketPlace: 'Zum JOMATIK Marktplatz',
};
